import { useCallback } from "react";
import { useWorkOrderStore } from "../../store/wo-order";
import useGetWorkOrder from "../useGetWorkOrder";
import { getMeters } from "../../api/Meters";

export default function useGetMeterReading() {
  const { trigger } = useGetWorkOrder();
  const setMeterReading = useWorkOrderStore(
    (state) => state.setWoMeterReadings
  );

  const getMeterReading = useCallback(
    async (woNumber: string) => {
      let currentWo = useWorkOrderStore.getState().getWorkOrderById(woNumber);
      if (!currentWo) {
        const response = await trigger(woNumber);
        if (response.status === 200) currentWo = response.data;
      }

      if (!currentWo?.Equipment) return; // unable to get the work order
      const equipSerialInd = currentWo.WriteWoToSerialFlag === true ? "s" : "e";
      const meterData = {
        equipSerialId: currentWo.Equipment,
        equipSerialInd,
      };
      const response = await getMeters(meterData);
      setMeterReading(woNumber, response.data);
      return response;
    },
    [setMeterReading, trigger]
  );

  return { getMeterReading };
}
